import { render, staticRenderFns } from "./AppNoteEditor.vue?vue&type=template&id=10815e5f&scoped=true"
import script from "./AppNoteEditor.vue?vue&type=script&lang=js"
export * from "./AppNoteEditor.vue?vue&type=script&lang=js"
import style0 from "./AppNoteEditor.vue?vue&type=style&index=0&id=10815e5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10815e5f",
  null
  
)

export default component.exports